module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09NRHG38S.68b60363.jpg";